<div class="fxc">
  <!-- from -->
  <div class="fxc-field">
    <app-dropdown class="fxc-dd" [options]="currencyOptions" [value]="from()" [searchable]="true"
                  (valueChange)="from.set($any($event))" size="sm" width="full"></app-dropdown>
    <input class="fxc-amt" inputmode="decimal" [value]="amountText()" (input)="onAmount($event)" placeholder="0" />
    <span class="fxc-sym">{{ fromSym() }}</span>
  </div>

  <div class="fxc-mid">
    <div class="fxc-line"></div>
    <button class="fxc-swap" (click)="swap()" title="Swap"><app-icon name="Swap" [size]="16"></app-icon></button>
    <div class="fxc-line"></div>
  </div>

  <!-- to -->
  <div class="fxc-field">
    <app-dropdown class="fxc-dd" [options]="currencyOptions" [value]="to()" [searchable]="true"
                  (valueChange)="to.set($any($event))" size="sm" width="full"></app-dropdown>
    <div class="fxc-amt out">{{ outText() }}</div>
    <span class="fxc-sym">{{ toSym() }}</span>
  </div>

  <div class="fxc-rate">1 {{ from() }} = <b>{{ pairText() }}</b> {{ to() }}</div>
  <div class="fxc-foot">
    <span>Effective {{ eff() }}</span>
    <span class="fxc-src">Reference Data · Currencies &amp; FX</span>
  </div>
</div>
